import type { OrganisationFiltersDTO } from "src/api/models";
import { getFetchOrganisation, postFetchAllOrganisations, postSyncOrganisations } from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";
import type { PaginationParams } from "src/composables/ticket-entities/types";

export interface SyncOrganisationsResult {
  created: number;
  updated: number;
  skipped: number;
  contacts_created: number;
}

export function useOrganisationService() {
  const { showSuccess, showError } = useNotification();

  async function fetchOrganisation(organisationId: string) {
    try {
      const response = await getFetchOrganisation(organisationId);
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchOrganisations(filters?: OrganisationFiltersDTO, pagination?: PaginationParams) {
    try {
      const response = await postFetchAllOrganisations(
        filters ?? null,
        {
          limit: pagination?.limit ?? 50,
          page: pagination?.page ?? 1,
        }
      );
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function synchroniseOrganisationsInBackend(): Promise<SyncOrganisationsResult> {
    try {
      const result = await postSyncOrganisations() as unknown as SyncOrganisationsResult;
      return result;
    } catch (error) {
      throw error;
    }
  }

  return {
    fetchOrganisation,
    fetchOrganisations,
    synchroniseOrganisationsInBackend,
  };
}
